import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideHistory } from '@ng-icons/lucide';
import { HlmTableImports } from '@spartan-ng/helm/table';
import { HlmTypographyImports } from '@spartan-ng/helm/typography';
import { PartnerAction } from '../../../../../services/partner-access.service';

/** What agencies changed in the account, newest first. */
@Component({
  selector: 'app-partner-action-log',
  standalone: true,
  imports: [DatePipe, NgIcon, HlmTableImports, HlmTypographyImports],
  providers: [provideIcons({ lucideHistory })],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './partner-action-log.component.html',
})
export class PartnerActionLogComponent {
  readonly actions = input.required<PartnerAction[]>();
}
